import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import List from './List';
import Details from './Details';


export default function UpdatesRoutes() {
  return (
    <Routes>
      <Route index element={<List />} />
      <Route path="list" element={<List />} />
      <Route path="details/:id" element={<Details />} />
      <Route
        path="*"
        element={
          <div style={{ paddingTop: 40, textAlign: 'center' }}>
            Not found
          </div>
        }
      />
    </Routes>
  );
}